import LineShader from "_src/shaders/line/line";
import objFactory from "_src/engine/factories/object";
import primitiveFactory from "_src/engine/factories/primitive";
import {primitiveType} from "_src/engine/constants";
import windowManager from "_src/client/window_manager";
import workspace from "_src/workspace";
import appState from "_src/app_state";
import objState from "_src/obj_state";
import {screenUtils} from "_src/client/utils";

const NORMALS_WIDTH = 2;
const NORMALS_COLOR = [0.816, 0.075, 1.0, 1.0];

let _normalsDrawable = null;

export default {
  init() {
    const shader = new LineShader({
      lineWidth: NORMALS_WIDTH,
      transparent: true,
      instancedMode: true,
      diffuseColor: NORMALS_COLOR,
    });

    _normalsDrawable = objFactory.createDrawable(shader);
    _normalsDrawable.addGeometryChunk(primitiveFactory.create(primitiveType.LINE));
    _normalsDrawable.setDiffuseColor(NORMALS_COLOR[0], NORMALS_COLOR[1], NORMALS_COLOR[2]);

    const mainRenderGraph = windowManager.getWindow(windowManager.MAIN).renderGraph;
    const interfaceScene = mainRenderGraph.getInterfaceScene();

    _normalsDrawable.setFrustrumCulling(false);
    _normalsDrawable.setVisibility(false);
    interfaceScene.add(_normalsDrawable);

    this.updateLength();
  },

  setEnabled(enabled) {
    _normalsDrawable.setVisibility(enabled);
    windowManager.getWindow(windowManager.MAIN).renderGraph.requestFrame();
  },

  update(objectWrappers = workspace.getObjects()) {
    const importedDrawables = [];
    for (const objectWrapper of objectWrappers) {

      if (!objectWrapper.getState(objState.OS_NORMAL)) {
        continue;
      }

      for (const frame of objectWrapper.frames) {
        if (frame.model.checkIsHidden()) {
          continue;
        }

        importedDrawables.push(frame.model);
      }
    }

    _normalsDrawable.importModelsForInstancing(importedDrawables);
  },

  clear() {
    _normalsDrawable.importModelsForInstancing([]);
  },

  updateLength() {
    const virtualLength = appState.getStateValue("normalsLength");
    const pixelRatio = screenUtils.getPixelRatio();
    const physicalLength = virtualLength * pixelRatio;
    _normalsDrawable.shader.setLineLength(physicalLength);
  },

  cleanup() {
    _normalsDrawable = null;
  }

}
